export function isMobile() {
  return /Mobi|Android|Tablet/i.test(navigator.userAgent)
}
